import __vue_normalize__ from '@gig/magic-wand/dist/build/rollup/vue-helpers/normalize-component.js';
import __vue_create_injector__ from 'vue-runtime-helpers/dist/inject-style/browser.mjs';
import magicStyles from './file-upload.magic.css.js';
import FileUploadComponent from './file-upload.js';
export { UploadStatus } from './file-upload.js';

const __vue_script__ = FileUploadComponent;

/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "magic-ui-box",
    { staticClass: "file-upload", attrs: { part: "file-upload" } },
    [
      _c(
        "div",
        { staticClass: "header", attrs: { part: "header" } },
        [
          _vm.hint
            ? _c(
                "magic-ui-sticky-tooltip",
                [
                  _c(
                    "div",
                    {
                      staticClass: "wrapper",
                      attrs: { slot: "clickable", part: "wrapper" },
                      slot: "clickable"
                    },
                    [
                      _c("magic-ui-text", {
                        staticClass: "title",
                        attrs: { part: "title", content: _vm.header }
                      }),
                      _vm._v(" "),
                      _c("magic-ui-icon", {
                        staticClass: "icon icon--header",
                        attrs: { name: "info", part: "icon icon--header" }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("magic-ui-text", {
                    staticClass: "text",
                    attrs: {
                      slot: "content",
                      part: "text",
                      "data-v-test-id": "hint-content",
                      content: _vm.hint
                    },
                    slot: "content"
                  })
                ],
                1
              )
            : _c("magic-ui-text", {
                staticClass: "title",
                attrs: { part: "title", content: _vm.header }
              })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "content", attrs: { part: "content" } },
        [
          !_vm.isNormal(_vm.status)
            ? _c(
                "div",
                {
                  staticClass: "status",
                  class: {
                    "status--verified": _vm.isVerified(_vm.status),
                    "status--pending": _vm.isPending(_vm.status),
                    "status--rejected":
                      _vm.isFailed(_vm.status) || _vm.isRejected(_vm.status)
                  },
                  attrs: {
                    "data-v-test-id": "file-upload-status",
                    part: _vm.$p("status", {
                      "status--verified": _vm.isVerified(_vm.status),
                      "status--pending": _vm.isPending(_vm.status),
                      "status--rejected":
                        _vm.isFailed(_vm.status) || _vm.isRejected(_vm.status)
                    })
                  }
                },
                [
                  _c("magic-ui-text", {
                    staticClass: "text",
                    attrs: {
                      part: "text",
                      content: _vm.$t(_vm.getStatusTranslation(_vm.status))
                    }
                  }),
                  _vm._v(" "),
                  _c("magic-ui-icon", {
                    staticClass: "icon icon--status",
                    attrs: {
                      part: "icon icon--status",
                      name: _vm.getStatusIcon(_vm.status)
                    }
                  })
                ],
                1
              )
            : _c(
                "div",
                { staticClass: "status", attrs: { part: "status" } },
                [_vm._t("default")],
                2
              ),
          _vm._v(" "),
          !_vm.isVerified(_vm.status) ? _vm._t("before-files") : _vm._e(),
          _vm._v(" "),
          !_vm.isVerified(_vm.status) &&
          (_vm.uploadedFiles.length > 0 || _vm.files.length > 0)
            ? _c(
                "ul",
                { staticClass: "files", attrs: { part: "files" } },
                [
                  _vm._l(_vm.uploadedFiles, function(file, i) {
                    return _c(
                      "li",
                      {
                        key: "uploaded-" + i,
                        staticClass: "file",
                        attrs: { part: "file" }
                      },
                      [
                        _c("magic-ui-text", {
                          staticClass: "text",
                          attrs: {
                            part: "text",
                            "data-v-test-id": "uploadedDate",
                            content: _vm._f("formatDate")(file.dateUploaded)
                          }
                        }),
                        _vm._v(" "),
                        _c("magic-ui-icon", {
                          staticClass: "icon",
                          class: [
                            "icon--file",
                            _vm.getStatusIconClass(file.statusText)
                          ],
                          attrs: {
                            part: _vm.$p("icon", [
                              "icon--file",
                              _vm.getStatusIconClass(file.statusText)
                            ]),
                            name: _vm.getStatusIcon(file.statusText)
                          }
                        })
                      ],
                      1
                    )
                  }),
                  _vm._v(" "),
                  _vm._l(_vm.files, function(ref, i) {
                    var file = ref.file;
                    var progress = ref.progress;
                    var hasError = ref.hasError;
                    return _c(
                      "li",
                      {
                        key: "file-" + i,
                        staticClass: "file",
                        attrs: { part: "file" }
                      },
                      [
                        _c("magic-ui-text", {
                          staticClass: "text",
                          attrs: {
                            part: "text",
                            "unsafe-content": hasError
                              ? _vm.$t("file-upload.upload-failed")
                              : file.name + " (" + progress + "%)"
                          }
                        }),
                        _vm._v(" "),
                        _c("magic-ui-icon", {
                          staticClass: "icon icon--file",
                          class: !hasError
                            ? "icon--file-pending"
                            : "icon--file-rejected",
                          attrs: {
                            part: _vm.$p(
                              "icon icon--file",
                              !hasError
                                ? "icon--file-pending"
                                : "icon--file-rejected"
                            ),
                            name: hasError ? "file-upload" : "timestamp"
                          }
                        })
                      ],
                      1
                    )
                  })
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.isVerified(_vm.status) && !_vm.disabled
            ? [
                _c(
                  "div",
                  { staticClass: "action", attrs: { part: "action" } },
                  [
                    _c("input", {
                      ref: "fileInput",
                      staticClass: "input",
                      attrs: {
                        hidden: "",
                        multiple: "",
                        id: "fileInput",
                        part: "input",
                        type: "file",
                        accept: _vm.supportedFileTypes.join(",")
                      },
                      on: { change: _vm.fileChosen }
                    }),
                    _vm._v(" "),
                    _c("magic-ui-button", {
                      staticClass: "button",
                      attrs: {
                        wide: "",
                        "no-margin": "",
                        variant: "primary",
                        "button-tag": "label",
                        part: "button",
                        for: "fileInput",
                        "data-v-test-id": "file-upload-button",
                        loading: _vm.hasPendingUpload
                      },
                      domProps: {
                        innerHTML: _vm._s(_vm.$t("file-upload.button"))
                      },
                      on: {
                        click: function($event) {
                          return _vm.$refs.fileInput.click()
                        }
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                !_vm.magicConfig.mobile
                  ? _c(
                      "div",
                      {
                        staticClass: "file-drop",
                        attrs: { part: "file-drop" },
                        on: {
                          drop: function($event) {
                            $event.preventDefault();
                            return _vm.fileDropped($event)
                          },
                          dragover: function($event) {
                            $event.preventDefault();
                          },
                          click: function($event) {
                            return _vm.$refs.fileInput.click()
                          }
                        }
                      },
                      [
                        _c("magic-ui-icon", {
                          staticClass: "icon icon--file-drop",
                          attrs: {
                            name: "upload",
                            part: "icon icon--file-drop"
                          }
                        }),
                        _vm._v(" "),
                        _c("magic-ui-text", {
                          staticClass: "text",
                          attrs: {
                            part: "text",
                            content: _vm.$t("file-upload.introduction")
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ]
            : _vm._e()
        ],
        2
      )
    ]
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-d0a6432e_0", { source: magicStyles, map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-d0a6432e";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  );

export default __vue_component__;
